import { IState } from '../types/state';

const deleteUser = (state: IState) => {
  state.user.data = undefined;
};

export default deleteUser;
